<template>
	<v-row>
    <v-snackbar :color="snackbar.color" v-model="snackbar.status" :timeout="snackbar.timeout" dark>
      <span class="text-caption font-weight-bold text-uppercase">{{snackbar.text}}</span>
      <template v-slot:action="{ attrs }">
        <v-btn class="font-weight-bold" text v-bind="attrs" @click="snackbar.status = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialogAlteraGrupo" max-width="500px">
      <v-card v-if="dados.grupo">
        <v-card-title class="primary white--text">
          Alterar Grupo
          <v-spacer />
          <v-btn icon @click="dialogAlteraGrupo=false" color="white"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-progress-linear indeterminate absolute :active="carregando" />
        <v-card-text class="mt-4">
          <v-select
            label="Grupo"
            item-value="idgrupo"
            item-text="grupo"
            :items="grupos"
            outlined
            v-model="dados.grupo.idgrupo"
            dense
            hide-details="auto"
            @change=";buscaGrupos()"
          >
          </v-select>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn class="primary" width="100%" @click="atualizaGrupo()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
		<v-col cols="12" md="4">
			<v-card class="mx-auto">
				<v-card-title>Informações</v-card-title>
				<v-divider />
				<v-progress-linear indeterminate absolute :active="carregando" />
				<v-card-text>
					<div class="my-3">
						<v-icon class="mr-2">mdi-identifier</v-icon>
						<span class="font-weight-bold">ID:</span>
						{{dados.idusuario}}
					</div>
					<div class="my-3">
						<v-icon class="mr-2">mdi-account-outline</v-icon>
						<span class="font-weight-bold">Nome:</span>
						{{dados.nome}}
					</div>
					<div class="my-3">
						<v-icon class="mr-2">mdi-account</v-icon>
						<span class="font-weight-bold">Usuário:</span>
						{{dados.usuario}}
					</div>
					<div v-if="dados.filial" class="my-3">
						<v-icon class="mr-2">mdi-office-building</v-icon>
						<span class="font-weight-bold">Filial:</span>
						{{dados.filial.filial}}
					</div>
					<div v-if="dados.grupo" class="my-3">
						<v-icon class="mr-2">mdi-account-multiple</v-icon>
						<span class="font-weight-bold">Grupo:</span>
						{{dados.grupo.grupo}}
            <v-btn icon class="primary ml-1" dark x-small @click="dialogAlteraGrupo=true"><v-icon x-small>mdi-pencil</v-icon></v-btn>
					</div>
					<div class="my-3">
						<v-icon class="mr-2">mdi-account-group-outline</v-icon>
						<span class="font-weight-bold">Departamento:</span>
						{{dados.departamento}}
					</div>
					<div class="my-3">
						<v-icon class="mr-2">mdi-account-check</v-icon>
						<span class="font-weight-bold mr-3">Status:</span>
						<v-chip v-if="dados.status" small color="success" class="font-weight-bold">Ativo</v-chip>
						<v-chip v-else dark color="red" small class="font-weight-bold">Inativo</v-chip>
					</div>
					<div class="my-3">
						<v-icon class="mr-2">mdi-clock</v-icon>
						<span class="font-weight-bold">Último acesso:</span>
						{{dados.dtultimologin}}
					</div>
				</v-card-text>
				<v-card-actions class="pa-4">
					<v-spacer />
					<v-btn
						:disabled="carregando"
						color="primary"
						elevation="0"
						v-if="!dados.status"
						@click="ativaInativaUsuario()"
					>Ativar Usuário</v-btn>
					<v-btn
						:disabled="carregando"
						color="primary"
						elevation="0"
						v-else
						@click="ativaInativaUsuario()"
					>Inativar Usuário</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
		<v-col cols="12" md="8">
			<UsuarioGrupoListaPermissao
        ref="usuarioGrupoPermissao"
				v-if="dados.grupo"
				:idgrupo="dados.grupo.idgrupo"
				:idusuario="dados.idusuario"
				:alterarPermissao="false"
			/>
		</v-col>
	</v-row>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import UsuarioGrupoListaPermissao from "../Usuario/UsuarioGrupoListaPermissao";

export default {
	name: "UsuarioGet",
	components: { UsuarioGrupoListaPermissao },
	props: ["idusuario"],
	data: () => ({
		carregando: false,
    dialogAlteraGrupo: false,
    grupos: [],
		dados: { grupos: []},
    snackbar: { status: false, timeout: 3000 },
	}),
	computed: {
		...mapState(["backendUrl", "pgLimit"]),
	},
	methods: {
		get() {
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}usuario/get`, {
					idusuario: parseInt(this.idusuario),
				})
				.then((res) => {
					this.dados = res.data;
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		ativaInativaUsuario() {
			return axios
				.post(`${this.backendUrl}usuario/status`, {
					idusuario: parseInt(this.idusuario),
					ativa: !this.dados.status,
				})
				.then(() => {
					this.get();
				});
		},
    buscaGrupos() {
			return axios
				.post(`${this.backendUrl}usuario/grupo/listar`, {
          limit: 9999,
          offset: 0,
        })
				.then((res) => {
					this.grupos= res.data.lista;
				});
		},
    atualizaGrupo() {
      return axios
          .post(`${this.backendUrl}usuario/grupo/atualizar`, {
            idusuario: parseInt(this.dados.idusuario),
            idgrupo: parseInt(this.dados.grupo.idgrupo),
          })
          .then(() => {
            this.$refs.usuarioGrupoPermissao.listar();
            this.get();
            this.dialogAlteraGrupo = false;
            this.snackbar.text = "Grupo atualizado com sucesso";
            this.snackbar.color = 'success'
            this.snackbar.status = true;
          })
          .catch((error) => {
            this.snackbar.text = error.response.data;
            this.snackbar.color = 'error';
            this.snackbar.status = true;
          });
    },
	},
	created() {
		this.get();
		this.buscaGrupos();
	},
};
</script>

<style scoped>
</style>